import { NgModule } from '@angular/core';

import { CardLoaderComponent } from './card-loader.component';

@NgModule({
  imports: [CardLoaderComponent],
  exports: [CardLoaderComponent]
})
export class CardLoaderModule {}
